import type { ApiResponse } from 'apisauce'
import type { ErrorRes } from '../../Types/Api/Error'
import type {
  IUser,
  LoginOkResponse,
  LoginResponse,
} from '../../Types/LeadGrid'
import { api, loginAPI } from './API'

export const login = async (
  email: string,
  password: string,
): Promise<LoginResponse> => {
  const response = await loginAPI.post('/oauth/token', {
    username: email,
    password,
    grant_type: 'password',
    // @ts-ignore
    client_id: window.CLIENT_ID,
    // @ts-ignore
    client_secret: window.CLIENT_SECRET,
    provider: 'cms_admins',
  })

  if (response.ok && response.data !== undefined) {
    saveAuthToken(response.data)
    const user = await requireAuth<any>(api.get<IUser>('me'))

    return {
      user: user.data,
      status: 200,
    }
  }

  return {
    status: response.status,
  }
}

export const signup = async (values) => {
  const res = await loginAPI.post<LoginOkResponse>('/api/cms_admin/register', {
    grant_type: 'password',
    // @ts-ignore
    client_id: window.CLIENT_ID,
    // @ts-ignore
    client_secret: window.CLIENT_SECRET,
    provider: 'cms_admins',
    ...values,
  })

  return res
}

export const logout = async () => {
  try {
    await requireAuth(api.delete('logout'))
  } catch (err) {
    alert(err)
  }
}

export const passwordReset = async (values) => {
  const res = await loginAPI.post<LoginOkResponse>(
    '/api/cms_admin/password/reset',
    {
      grant_type: 'password',
      // @ts-ignore
      client_id: window.CLIENT_ID,
      // @ts-ignore
      client_secret: window.CLIENT_SECRET,
      provider: 'cms_admins',
      ...values,
    },
  )

  return res
}

//
// Utilities
//

export function saveAuthToken(token) {
  localStorage.setItem('authToken', JSON.stringify(token))
}

export function getAccessToken() {
  const authToken = JSON.parse(localStorage.getItem('authToken') || '{}')

  return authToken.access_token
}

export async function requireAuth<T>(
  promise: Promise<ApiResponse<T | ErrorRes>>,
) {
  const response = await promise

  if (response.status === 401 || response.status === 403) {
    // ログイン画面に遷移
    localStorage.clear()
    location.reload()
  }

  return response
}

/**
 * APIからのレスポンスがエラーかどうかを判定するタイプガード
 *
 * 使い方
 *
 * ```
 * const res = await LeadGrid.storeEmailDomain(emailDomain, siteId, name)
 * if (isResErrorType(res.data)) {
 *   // res.dataがIErrorResとして実装できる
 * }
 * ```
 *
 * @param arg response.data を渡す
 * @returns IErrorRes形式の場合trueを返す
 */
export function isResErrorType(arg: unknown): arg is ErrorRes {
  if (arg === null || arg === undefined) {
    return false
  }

  return typeof arg === 'object' && arg !== null && ('errors' in arg || 'exception' in arg)
}
